import { z } from "zod";
import { dmaSettingParameterDtoSchema } from "../dma-setting-parameter/dma-setting-parameter.schema";
export const dmaRequestedMiniModelDtoSchema = z.object({
    miniModelId: z.number(),
    parameters: z.array(dmaSettingParameterDtoSchema),
});
